module.exports = "/images/more-vertical.svg?b25e198b858faca4dd3d416923280ffe";